(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smartgear-context-browse"] && !Shopify.designMode) return;
  try {
    (()=>{
  document.addEventListener('click',e=>{
    const link=e.target.closest('.sg-browse-quick a[href^="#"]');
    if(!link)return;
    const target=document.getElementById(link.hash.slice(1));
    if(!target)return;
    e.preventDefault();e.stopImmediatePropagation();
    requestAnimationFrame(()=>{
      window.scrollTo({top:target.getBoundingClientRect().top+window.scrollY-220,behavior:'instant'});
      const heading=target.querySelector('h2');
      if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}
    });
  },true);
  const init=(root)=>{
    root.querySelectorAll('.sg-context-browse').forEach(section=>{
      if(section.dataset.sgReady)return;
      section.dataset.sgReady='true';
      const rail=section.querySelector('.sg-browse-rail'),controls=section.querySelector('.sg-browse-controls');
      if(rail&&controls){
        const update=()=>{const max=rail.scrollWidth-rail.clientWidth;controls.hidden=max<2;controls.querySelector('[data-sg-step="-1"]').disabled=rail.scrollLeft<2;controls.querySelector('[data-sg-step="1"]').disabled=rail.scrollLeft>=max-2;};
        controls.addEventListener('click',e=>{const button=e.target.closest('[data-sg-step]');if(!button)return;const card=rail.querySelector('.sg-browse-card');rail.scrollBy({left:Number(button.dataset.sgStep)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
        rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
      }
      section.querySelectorAll('.sg-browse-choose').forEach(details=>{
        details.addEventListener('toggle',()=>{if(details.open)section.querySelectorAll('.sg-browse-choose').forEach(other=>{if(other!==details)other.open=false;});});
        details.addEventListener('keydown',e=>{if(e.key==='Escape'){details.open=false;details.querySelector('summary').focus();}});
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
